import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import L from "leaflet";

// Remove the "Leaflet" prefix/flag from every map; keep only the required OpenStreetMap credit.
L.Control.Attribution.prototype.options.prefix = false;

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Build-time prerendered public pages hydrate only on their own route; anything else renders fresh.
if (container.dataset.prerendered && container.dataset.prerendered === (window.location.pathname.replace(/\/+$/, "") || "/")) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
